

const ACTION_TYPE = {
    LOAD_LAST_NOTIFICATIONS: "LOAD_LAST_NOTIFICATIONS",
    NEW_NOTIFICATION: "NEW_NOTIFICATION",
    READ_NOTIFICATION: "READ_NOTIFICATION"
}

const reducers = (state, action) => {
    switch (action.type) {
        case ACTION_TYPE.LOAD_LAST_NOTIFICATIONS: {
            return {
                notifications: action.data.notifications
            }
        }
        case ACTION_TYPE.NEW_NOTIFICATION: {
            return {
                notifications: [action.data, ...state.notifications]
            }
        }
        case ACTION_TYPE.READ_NOTIFICATION: {
            return {
                notifications: state.notifications.map(notification => {
                    if(notification.relation == action.data)
                        notification.read_at = new Date();

                    return notification
                })
            }
        }
    }
    return state;
}

export {
    ACTION_TYPE,
    reducers
};